import React from 'react';
import {_GPY} from '../../../env.js'
import GpyToggleButton from './GpyToggleButton.js';
import GpyScoreButton from '../lib/GpyScoreButton.js';

class ScoreboardTeamScorePanel extends React.Component {

	constructor(props) {
		super(props);
		this.state = {
			scoreValues:this.props.scoreValues!==undefined?this.props.scoreValues:[1],
			needPeriodIndex : this.props.needPeriodIndex!==undefined?this.props.needPeriodIndex:false,
	  };
	}

	componentDidMount() {
	}

	updateDependencies() {
			if ( this.props.getUpdateDependenciesComponents!==undefined ) {
			var l = this.props.getUpdateDependenciesComponents();
			  for(var i=0;i<l.length;i++) {
			    if(this.props.scoreboard.state.components[l[i]]!==undefined && this.props.scoreboard.state.components[l[i]].isActive()) {
				     this.props.scoreboard.state.components[l[i]].updateData();
		 	    }
		  	}
    	}
  }

  render () {
//		const sponsorLogo = this.props.scoreboard.state.currentGame.sponsorLogo!==undefined&&this.props.scoreboard.state.currentGame.sponsorLogo!==''?this.props.scoreboard.state.currentGame.sponsorLogo:"empty.png";

    return (
			<>
			<div className="row" style={this.state.needPeriodIndex&&this.props.scoreboard.state.currentPeriodIndex<=0?{pointerEvents:"none",opacity: "0.4"}:{pointerEvents:"auto",opacity: "1"}}>
			 <div className="col-4 font-weight-bold text-center">
					 {this.props.scoreboard.state.currentGame!==undefined&&this.props.scoreboard.state.currentGame.teamMap!==undefined&&this.props.scoreboard.state.currentGame.teamMap.HOME_TEAM!==undefined?
					    <span>{this.props.scoreboard.state.currentGame.teamMap.HOME_TEAM.name}</span>
					 :""}
			 </div>
			 <div className="col-4"></div>
			 <div className="col-4 font-weight-bold text-center">
					 {this.props.scoreboard.state.currentGame!==undefined&&this.props.scoreboard.state.currentGame.teamMap!==undefined&&this.props.scoreboard.state.currentGame.teamMap.GUEST_TEAM!==undefined?
							<span>{this.props.scoreboard.state.currentGame.teamMap.GUEST_TEAM.name}</span>
					 :""}
			 </div>




			 <div className="col-4">
						<GpyScoreButton min="0" max="300" stateName={this.props.scoreboard.getName()+"_score_home"} scoreboard={this.props.scoreboard} getTime={()=>this.props.scoreboard.getCurrentMainTime()} getGameId={()=>this.props.scoreboard.getCurrentGameId()}
							  onChangeScore={(score)=>{
									console.log("onChangeScoreH",score,this.props.onChangeHomeScore);
													 if( this.props.onChangeHomeScore !== undefined ){
														 this.props.onChangeHomeScore(score,()=>{
															 	this.updateDependencies();
														 });
														 return;
													 }
													 var ds = this.props.scoreboard.state.dataStore;
													 if(ds.score === undefined ) ds.score = {};
													 ds.score.home = score;
													 this.props.scoreboard.setState({dataStore:ds},()=>{
																this.props.scoreboard.storeData();
																this.updateDependencies();
													 });
								}}
						/>

			</div>
			<div className="col-4"><p className="text-center">:</p></div>
			<div className="col-4">
			       <GpyScoreButton  min="0" max="300" stateName={this.props.scoreboard.getName()+"_score_guest"} scoreboard={this.props.scoreboard} getTime={()=>this.props.scoreboard.getCurrentMainTime()} getGameId={()=>this.props.scoreboard.getCurrentGameId()}
						   	onChangeScore={(score)=>{
									console.log("onChangeScoreG",score);
														if(this.props.onChangeGuestScore!==undefined){
															this.props.onChangeGuestScore(score,()=>{
 															 	this.updateDependencies();
 														 });
 														 return;
														}
								            var ds = this.props.scoreboard.state.dataStore;
														if(ds.score === undefined ) ds.score = {};
 	 													ds.score.guest = score;
 	 													this.props.scoreboard.setState({dataStore:ds},()=>{
 	 															this.props.scoreboard.storeData();
																this.updateDependencies();
 	 													});
									}}
							/>
			</div>




			{this.state.scoreValues.map((scoreValue)=>{
				var scoreValueKey = scoreValue===1?"":"_score_"+scoreValue;
				return (
					<>
					<div className="col-4 p-1">
			 			<GpyToggleButton keyCode={scoreValue===1?"h":undefined} title={_GPY.i18n.get('gametype_'+this.props.scoreboard.getName()+'_scoreboard_goal'+scoreValueKey+'_home_button')}
			 				onInit={() => {return {}}}
			 				onDeactivate={() => {return {visible: false}}}
			 				onActivate={() => {
			 					this.props.scoreboard.state.components[this.props.scoreboard.getName()+'_score_home'].incrementScore(scoreValue);
			 					var m = this.props.scoreboard.getCurrentMainTime();
			 					var minF = (m/1000) / 60 ;
			 					var min = Math.floor(minF) ;
			 					var sec = Math.floor((minF-min)*60);

			 					var formatMin = ('00'+min).slice(-2);
			 					var formatSec = ('00'+sec).slice(-2);

			 					let res =  {visible: true,
			 						playerName : this.props.scoreboard.state.currentGame.teamMap.HOME_TEAM.name,
			 						player: {id:-1, firstName:"", lastName: this.props.scoreboard.state.currentGame.teamMap.HOME_TEAM.name, numOrPos:"", playerId:"", vsRole:"HOME_TEAM_PLAYER", profileImage: "default_avatar.png"},
			 						team: this.props.scoreboard.state.currentGame.teamMap.HOME_TEAM,
			 						time: m,
			 						minute: formatMin,
			 						second: formatSec,
									scoreValue: scoreValue,
			 					}
								if(this.props["onActivateHome"+scoreValue]!==undefined) {
									res = this.props["onActivateHome"+scoreValue](res);
								}
								return res;
								}}
			 					scoreboard={this.props.scoreboard}
			 					getTime={()=>this.props.scoreboard.getCurrentMainTime()} getGameId={()=>this.props.scoreboard.getCurrentGameId()}
			 				stateName={this.props.scoreboard.getName()+"_button_goal"+scoreValueKey+"_home"}
			 				autoexpirytime="10" />
			 	 </div>


			 	 <div className="col-4 p-1">
			 		 <GpyToggleButton keyCode={scoreValue===1?"p":undefined} title={_GPY.i18n.get('gametype_'+this.props.scoreboard.getName()+'_scoreboard_goal'+scoreValueKey+'_player_button')}
			 			 condition={() => {return (this.props.scoreboard.playerCountByRole("HOME_TEAM_PLAYER,GUEST_TEAM_PLAYER,HOME_TEAM_SUBSTITUE,GUEST_TEAM_SUBSTITUE")===1)}}
			 			 onInit={() => {return {}}}
			 			 onDeactivate={() => {return {visible: false}}}
			 			 onActivate={() => {

			 				 if(this.props.scoreboard.state.selectedPlayers['HOME_TEAM_PLAYER'] !== undefined || this.props.scoreboard.state.selectedPlayers['HOME_TEAM_SUBSTITUE'] !== undefined){
			 								this.props.scoreboard.state.components[this.props.scoreboard.getName()+'_score_home'].incrementScore(scoreValue);
			 				 }
			 				 if(this.props.scoreboard.state.selectedPlayers['GUEST_TEAM_PLAYER'] !== undefined || this.props.scoreboard.state.selectedPlayers['GUEST_TEAM_SUBSTITUE'] !== undefined){
			 								 this.props.scoreboard.state.components[this.props.scoreboard.getName()+'_score_guest'].incrementScore(scoreValue);
			 				 }

			 				 var m = this.props.scoreboard.getCurrentMainTime();
			 				 var minF = (m/1000) / 60 ;
			 				 var min = Math.floor(minF) ;
			 				 var sec = Math.floor((minF-min)*60);

			 				 var formatMin = ('00'+min).slice(-2);
			 				 var formatSec = ('00'+sec).slice(-2);

			 				 var p = this.props.scoreboard.state.selectedPlayers[Object.keys(this.props.scoreboard.state.selectedPlayers)[0]];
			 				 let res = {visible: true,
			 					 playerName : (p.firstName!==undefined && p.firstName!==''? p.firstName +" ":"") + (p.lastName!==undefined&&p.lastName!==''?p.lastName:"") ,
			 					 player:p,
			 					 team: this.props.scoreboard.getTeamByPlayer(p),
			 					 time: m,
			 					 minute: formatMin,
			 					 second: formatSec,
								 scoreValue: scoreValue,
			 				 }
							 if(this.props["onActivatePlayer"+scoreValue]!==undefined) {
						 		res = this.props["onActivatePlayer"+scoreValue](res);
						 	 }
							 return res;
						 }}
			 				 scoreboard={this.props.scoreboard}
			 				 getTime={()=>this.props.scoreboard.getCurrentMainTime()} getGameId={()=>this.props.scoreboard.getCurrentGameId()}
		   	 		 stateName={this.props.scoreboard.getName()+"_button_goal"+scoreValueKey+"_player"}
			 			 autoexpirytime="10" />
			 	 </div>


			 	 <div className="col-4 p-1">
			 	 <GpyToggleButton keyCode={scoreValue===1?"g":undefined} title={_GPY.i18n.get('gametype_'+this.props.scoreboard.getName()+'_scoreboard_goal'+scoreValueKey+'_guest_button')}
			 		 onInit={() => {return {}}}
			 		 onDeactivate={() => {return {visible: false}}}
			 		 onActivate={() => {

			 			 this.props.scoreboard.state.components[this.props.scoreboard.getName()+'_score_guest'].incrementScore(scoreValue);
			 			 var m = this.props.scoreboard.getCurrentMainTime();
			 			 var minF = (m/1000) / 60 ;
			 			 var min = Math.floor(minF) ;
			 			 var sec = Math.floor((minF-min)*60);

			 			 var formatMin = ('00'+min).slice(-2);
			 			 var formatSec = ('00'+sec).slice(-2);

			 			 let res = {visible: true,
			 				 playerName : this.props.scoreboard.state.currentGame.teamMap.GUEST_TEAM.name,
			 				 player: {id:-1, firstName:"", lastName: this.props.scoreboard.state.currentGame.teamMap.GUEST_TEAM.name, numOrPos:"", playerId:"", vsRole:"GUEST_TEAM_PLAYER", profileImage: "default_avatar.png"},
			 				 team: this.props.scoreboard.state.currentGame.teamMap.GUEST_TEAM,
			 				 time: m,
			 				 minute: formatMin,
			 				 second: formatSec,
							 scoreValue: scoreValue,
			 			 }
						 if(this.props["onActivateGuest"+scoreValue]!==undefined) {
							res = this.props["onActivateGuest"+scoreValue](res);
						 }
						 return res;
					 }}
			 			 scoreboard={this.props.scoreboard}
			 			 getTime={()=>this.props.scoreboard.getCurrentMainTime()} getGameId={()=>this.props.scoreboard.getCurrentGameId()}
			 		 stateName={this.props.scoreboard.getName()+"_button_goal"+scoreValueKey+"_guest"}
			 		 autoexpirytime="10"/>
			 	 </div>

				 </>
					)
			})}

		</div>

		 </>
		);
  }
}
export default ScoreboardTeamScorePanel;
